import * as yup from "yup";

const SUPPORTED_FORMATS = ["image/jpeg", "image/png", "video/mp4"];

export const schemaFormularioNotificar = yup.object().shape({
  motivo_id: yup.string().required("Este campo es obligatorio"),
  motivoManual: yup.string().when("motivo_id", {
    is: "otro",
    then: (schema) => schema.required("Este campo es obligatorio"),
  }),
  archivo: yup
    .mixed()
    .required("El archivo es obligatorio")
    .test("fileSize", "El archivo debe pesar menos de 10MB", (value) => {
      return value && value[0]?.size <= 10 * 1024 * 1024; // 10MB en bytes
    })
    .test("fileFormat", "El formato no es soportado", (value) => {
      return value && SUPPORTED_FORMATS.includes(value[0]?.type);
    }),
  observacion: yup.string().required("Este campo es obligatorio"),
  ubicacion: yup
    .array()
    .of(
      yup.number().required("Se requiere un valor numérico") 
    )
    .min(2, "Se requieren tanto la latitud como la longitud") 
    .required("Este campo es obligatorio"),
});
